import { ReactNode, useState } from 'react';
import { WatchDutyThemeProvider } from 'theme';

type ColorSchemeMode = 'light' | 'dark';

interface ForcedThemeProps {
  mode: ColorSchemeMode;
  children: ReactNode;
}

export const ForcedTheme = (props: ForcedThemeProps): JSX.Element => {
  const { mode, children } = props;
  const [node, setNode] = useState<HTMLDivElement | null>(null);

  const providerProps = {
    defaultMode: mode,
    modeStorageKey: `mui-forced-${mode}`,
    colorSchemeStorageKey: `mui-forced-cs-${mode}`,
    colorSchemeNode: node,
    disableNestedContext: true,
    disableStyleSheetGeneration: true,
    noSsr: true,
  };

  return (
    <div
      ref={setNode}
      {...{ [`data-${mode}`]: '' }}
      style={{ display: 'contents', color: 'var(--mui-palette-text-primary)' }}
    >
      <WatchDutyThemeProvider {...providerProps}>
        {children}
      </WatchDutyThemeProvider>
    </div>
  );
};
